import { useShallow } from 'zustand/react/shallow';
import { useUserStore } from '../../model';

export const useCustomerId = () => {
  return useUserStore(useShallow(state => Number(state.user?.customerId || 0)));
};
